import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVeilig = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M16 13a4 4 0 1 1 8 0v7h3v-7a7 7 0 0 0-14 0z"
    />
    <path
      fill="#FF7842"
      d="M28.87 16H11.13A1.13 1.13 0 0 0 10 17.13v15.74c0 .624.506 1.13 1.13 1.13h17.74A1.13 1.13 0 0 0 30 32.87V17.13A1.13 1.13 0 0 0 28.87 16"
    />
    <path
      fill="#FFBFA5"
      d="M20 26a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
    <path
      fill="#FFBFA5"
      d="M21 24h-2l-1 6h4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.109 25.33a2.5 2.5 0 0 0 .391-1.332l1 .004a3.5 3.5 0 0 1-1.668 2.967l.661 3.948-.986.166-.783-4.674.343-.161c.427-.202.788-.52 1.041-.918M9.62 18.3a.62.62 0 0 0-.62.625V22.6H8v-3.668A1.62 1.62 0 0 1 9.62 17.3h4.88v1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVeilig);

export default ForwardRef;
